import { ReactElement, useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { getAppSession, createReauthState } from "lib/appSessionManager";

import PageLoading from "global-components/pageLoading/PageLoading";

// The Okta SecureRoute component does not support react-router-dom major version 6
// Need to create this custom component to replicate the behavior
const RequireAuth = ({
  render,
}: {
  render: () => ReactElement;
}): ReactElement => {
  const { oktaAuth, authState } = useOktaAuth();
  const session = getAppSession(authState);

  useEffect(() => {
    if (!authState) return;
    if (!authState?.isAuthenticated || !session) {
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin,
      );
      oktaAuth.setOriginalUri(originalUri);
      if (session) {
        oktaAuth.signInWithRedirect();
      } else {
        oktaAuth.signInWithRedirect({
          maxAge: 0,
          state: createReauthState(Date.now()),
        });
      }
    }
  }, [authState, oktaAuth, session]);

  if (!authState || !authState.isAuthenticated) {
    return <PageLoading />;
  }

  return render();
};

export default RequireAuth;
